"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return GenericS3;
    }
});
const _fs = /*#__PURE__*/ _interop_require_default(require("fs"));
const _util = require("util");
const _stream = require("stream");
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
const _axios = /*#__PURE__*/ _interop_require_default(require("axios"));
const _requestfilteringagent = require("request-filtering-agent");
const _clients3 = require("@aws-sdk/client-s3");
const _s3requestpresigner = require("@aws-sdk/s3-request-presigner");
const _libstorage = require("@aws-sdk/lib-storage");
const _pluginUtils = require("~/utils/pluginUtils");
const _ncError = require("~/helpers/ncError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let GenericS3 = class GenericS3 {
    get defaultParams() {
        return {
            Bucket: this.input.bucket
        };
    }
    async init() {
    // Placeholder, should be initialized in child class
    }
    patchKey(key) {
        return key;
    }
    patchUploadReturnKey(key) {
        return key;
    }
    async test() {
        try {
            const tempFile = (0, _pluginUtils.generateTempFilePath)();
            const createStream = _fs.default.createWriteStream(tempFile);
            await (0, _pluginUtils.waitForStreamClose)(createStream);
            await this.fileCreate('nc-test-file.txt', {
                path: tempFile,
                mimetype: 'text/plain',
                originalname: 'temp.txt',
                size: ''
            });
            await (0, _util.promisify)(_fs.default.unlink)(tempFile);
            return true;
        } catch (e) {
            _ncError.NcError._.pluginTestError(e == null ? void 0 : e.message);
        }
    }
    async fileRead(key) {
        try {
            const fileStream = await this.fileReadByStream(key);
            return new Promise((resolve, reject)=>{
                const chunks = [];
                fileStream.on('data', (chunk)=>{
                    chunks.push(chunk);
                });
                fileStream.on('end', ()=>{
                    const buffer = Buffer.concat(chunks);
                    resolve(buffer);
                });
                fileStream.on('error', (err)=>{
                    reject(err);
                });
            });
        } catch (error) {
            _ncError.NcError._.storageFileReadError(error.message);
        }
    }
    async fileCreate(key, file) {
        try {
            const fileStream = _fs.default.createReadStream(file.path);
            fileStream.on('error', (err)=>{
                _ncError.NcError._.storageFileCreateError(err.message);
            });
            return await this.fileCreateByStream(key, fileStream, {
                mimetype: file == null ? void 0 : file.mimetype
            });
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(error.message);
        }
    }
    async fileCreateByStream(key, stream, options) {
        try {
            const streamError = new Promise((_, reject)=>{
                stream.on('error', (err)=>{
                    reject(err);
                });
            });
            const uploadParams = _extends({}, this.defaultParams, {
                Body: stream,
                Key: key,
                ContentType: (options == null ? void 0 : options.mimetype) || 'application/octet-stream'
            });
            const upload = this.upload(uploadParams);
            return await Promise.race([
                upload,
                streamError
            ]);
        } catch (error) {
            _ncError.NcError._.storageFileStreamError(error.message);
        }
    }
    async fileCreateByUrl(key, url, { fetchOptions: { buffer } = {
        buffer: false
    } }) {
        try {
            const response = await _axios.default.get(url, {
                httpAgent: (0, _requestfilteringagent.useAgent)(url),
                httpsAgent: (0, _requestfilteringagent.useAgent)(url),
                responseType: buffer ? 'arraybuffer' : 'stream'
            });
            const uploadParams = _extends({}, this.defaultParams, {
                Body: response.data,
                Key: key,
                ContentType: response.headers['content-type']
            });
            const data = await this.upload(uploadParams);
            return {
                url: data,
                data: response.data
            };
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(`Failed to create file from URL: ${error.message}`);
        }
    }
    async getSignedUrl(key, expiresInSeconds = 7200, pathParameters) {
        try {
            const command = new _clients3.GetObjectCommand(_extends({
                Key: this.patchKey(key),
                Bucket: this.input.bucket
            }, pathParameters));
            return await (0, _s3requestpresigner.getSignedUrl)(this.s3Client, command, {
                expiresIn: expiresInSeconds
            });
        } catch (error) {
            _ncError.NcError._.storageFileReadError(`Failed to generate signed URL: ${error.message}`);
        }
    }
    async upload(uploadParams) {
        try {
            const upload = new _libstorage.Upload({
                client: this.s3Client,
                params: _extends({
                    ACL: 'public-read'
                }, uploadParams)
            });
            const data = await upload.done();
            return this.patchUploadReturnKey(data.Location);
        } catch (error) {
            _ncError.NcError._.storageFileCreateError(error.message);
        }
    }
    async fileReadByStream(key) {
        try {
            const command = new _clients3.GetObjectCommand({
                Key: this.patchKey(key),
                Bucket: this.input.bucket
            });
            const { Body } = await this.s3Client.send(command);
            const stream = Body;
            // Handle any stream errors that occur during reading
            stream.on('error', (error)=>{
                _ncError.NcError._.storageFileStreamError(error.message);
            });
            return stream;
        } catch (error) {
            _ncError.NcError._.storageFileStreamError(error.message);
        }
    }
    async getDirectoryList(prefix) {
        try {
            const response = await this.s3Client.listObjectsV2({
                Prefix: prefix,
                Bucket: this.input.bucket
            });
            return response.Contents.map((content)=>{
                return _path.default.basename(content.Key);
            });
        } catch (error) {
            _ncError.NcError._.storageFileReadError(`Failed to list directory: ${error.message}`);
        }
    }
    async fileDelete(key) {
        try {
            await this.s3Client.deleteObject({
                Key: this.patchKey(key),
                Bucket: this.input.bucket
            });
            return true;
        } catch (error) {
            _ncError.NcError._.storageFileDeleteError(error.message);
        }
    }
    async scanFiles(globPattern) {
        // remove all dots from the glob pattern
        globPattern = globPattern.replace(/\./g, '');
        // remove the leading slash
        globPattern = globPattern.replace(/^\//, '');
        // make sure pattern starts with nc/uploads/
        if (!globPattern.startsWith('nc/uploads/')) {
            globPattern = `nc/uploads/${globPattern}`;
        }
        // S3 does not support glob so remove *
        globPattern = globPattern.replace(/\*/g, '');
        const stream = new _stream.Readable({
            read () {}
        });
        stream.setEncoding('utf8');
        const listObjects = async (continuationToken)=>{
            try {
                const response = await this.s3Client.listObjectsV2(_extends({
                    Bucket: this.input.bucket,
                    Prefix: globPattern
                }, continuationToken ? {
                    ContinuationToken: continuationToken
                } : {}));
                response.Contents.forEach((content)=>{
                    stream.push(content.Key);
                });
                if (response.IsTruncated) {
                    await listObjects(response.NextContinuationToken);
                } else {
                    stream.push(null);
                }
            } catch (error) {
                stream.destroy(error);
            }
        };
        listObjects().catch((error)=>{
            stream.destroy(error);
        });
        return stream;
    }
    getUploadedPath(path) {
        return {
            path
        };
    }
    constructor(input){
        this.input = input;
    }
};
